import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import CardCarousel from '../../components/CardCarousel/CardCarousel'

import { getAccommodations } from '../../redux/reducers/accommodations'
import {
  getDescription,
  getTitle,
} from '../../redux/reducers/configuration'
import '../../styles/scss/views/accommodations-container.scss'

const AccommodationsContainer = () => {
  const accommodations = useSelector(getAccommodations)
  const description = useSelector(getDescription)
  const title = useSelector(getTitle)

  return Boolean(_.size(accommodations)) && (
    <div className="featured-accommodations">
      <div className="u-flex u-flex-column u-flex-align-center featured-accommodations__content-container">
        <div className="u-full-width featured-accommodations__content-container__background-skew" />
        {title && (
          <h2
            className="featured-accommodations__content-container__cards-header"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {description && (
          <div
            className="featured-accommodations__content-container__cards-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <div className="u-full-width">
          <CardCarousel accommodations={accommodations} />
        </div>
      </div>
    </div>
  )
}

export default AccommodationsContainer
